import {
  CurtainsClosedTwoTone,
  DoorSlidingSharp,
  NewReleases,
  Star,
} from "@mui/icons-material";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Image, Transformation } from "cloudinary-react";

const StyledDivRow = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  alignItems: "center",
});

const StyledAnchor = styled("a")({
  fontSize: 12,
  paddingLeft: 10,
  color: "blue",
});

const styles = {
  row: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: 6,
  },
  rowDark: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: "whitesmoke",
    padding: 6,
  },
  font: { fontSize: 30 },
};

const baseURL =
  "https://res.cloudinary.com/ag-millworks/image/upload/Latest_News_Icons/sdlBarsIcon";

const News = () => {
  return (
    <>
      {newsTopics.map((item, index) => (
        <div key={index} style={index % 2 !== 1 ? styles.rowDark : styles.row}>
          {index === 0 ? (
            <Star style={{ ...styles.font, color: "#eebe07" }} />
          ) : index === 1 ? (
            <Image
              cloudName="ag-millworks"
              secure="true"
              publicId={`Latest_News_Icons/sdlBarsIcon`}
            />
          ) : index === 2 ? (
            <NewReleases style={{ ...styles.font, color: "blue" }} />
          ) : index === 3 ? (
            <CurtainsClosedTwoTone style={{ ...styles.font, color: "black" }} />
          ) : index === 4 ? (
            <DoorSlidingSharp color="primary" style={styles.font} />
          ) : (
            <Image cloudName="ag-millworks" secure="true" publicId="millie30" />
          )}
          <StyledDivRow>
            <Typography
              style={{
                paddingLeft: 40,
                fontWeight: index === 0 ? "bold" : "normal",
                fontSize: index === 0 || index === 1 ? 15 : "1 rem",
              }}
            >
              {" "}
              {item.topic}
            </Typography>
            {(index === 0 || index === 3) && (
              <StyledAnchor target="_blank" rel="noreferrer" href={item.link}>
                Learn More
              </StyledAnchor>
            )}
          </StyledDivRow>
        </div>
      ))}
    </>
  );
};

const newsTopics = [
  {
    topic: "PICO Swings Now Available",
    link: "https://www.agmillworks.com/products/pico-swing",
  },
  {
    topic: '7/8" Exterior Flat Bar SDL Available',
  },
  {
    topic: "Bi-fold Combo units Available",
  },
  // {
  //   topic: "6% Price Increase Effective EOBD July 14th",
  //   link: "https://mailchi.mp/c9eb5a3f770f/upcoming-price-increase-effective-june-15-17245275",
  // },
  {
    topic: "Centor Screen/Shade available",
    link: "https://agmillworks.com/retractable-screens/",
  },
  {
    topic: "8ft x 10ft maximum Slider panel size",
  },
  {
    topic:
      "Virtual assistant will help catch potential mismatched options in your cart",
  },
];

export default News;
